import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import React from 'react';
import MobileAdhesionFs from './freestar/Adhesion';
import MobileAdhesionTab from './taboola/MobileAdhesion';
const MobileAdhesion = ({ safety = 'off', safetyState })=>{
    const isTaboola = useFlag('ads_taboola');
    if (isTaboola) {
        return /*#__PURE__*/ React.createElement(MobileAdhesionTab, {
            safety: safety,
            safetyState: safetyState
        });
    }
    return /*#__PURE__*/ React.createElement(MobileAdhesionFs, {
        safety: safety,
        safetyState: safetyState
    });
};
MobileAdhesion.displayName = 'MobileAdhesion';
export default MobileAdhesion;
